import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const CurvesStudioRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={656}
			style={{
				width: 2560,
				height: 1428,
			}}
		>
			<Video
				src="https://remotion.media/studio/effects/curves-capture-20261023-110026.mp4"
				durationInFrames={656}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						13, 31, 335, 344, 351, 354, 355, 358, 364, 366, 397, 408, 413, 542,
						543, 545, 548,
					],
					[
						'auto',
						'default',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 95, 284, 426, 531, 596, 602],
						[
							2.335766423357664, 2.102189781021898, 2.335766423357664,
							2.102189781021898, 2.335766423357664, 2.102189781021898,
							2.335766423357664,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							13, 22, 25, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
							72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 118,
							119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131,
							132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
							145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157,
							158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170,
							171, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 266, 267, 277,
							278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 303, 304, 305,
							306, 307, 308, 309, 326, 327, 328, 329, 330, 331, 332, 333, 334,
							335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347,
							348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360,
							361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 373, 374, 385,
							386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398,
							399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411,
							412, 413, 414, 415, 416, 417, 418, 421, 422, 440, 441, 442, 443,
							444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456,
							457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469,
							470, 471, 472, 473, 474, 475, 476, 477, 478, 487, 488, 489, 490,
							491, 492, 493, 494, 495, 496, 497, 498, 499, 500, 501, 502, 503,
							504, 505, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516,
							517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529,
							530, 531, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551,
							552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 562, 563, 564,
							565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 575, 576, 577,
							578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588,
						],
						[
							'1318.6678832116788px 1536.067518248175px',
							'2107.3722627737225px 1159.3886861313867px',
							'2133.631386861314px 1124.3521897810217px',
							'2163.3302919708026px 1077.9744525547444px',
							'2171.0583941605837px 1062.5px',
							'2180.684306569343px 1039.4251824817518px',
							'2201.4598540145985px 985.2828467153283px',
							'2206.605839416058px 954.3339416058393px',
							'2211.4142335766423px 927.6642335766422px',
							'2211.4142335766423px 905.2737226277371px',
							'2211.4142335766423px 892.9835766423357px',
							'2211.4142335766423px 880.6934306569342px',
							'2211.4142335766423px 876.0036496350365px',
							'2207.052919708029px 868.8503649635036px',
							'2197.874087591241px 848.2755474452554px',
							'2194.744525547445px 843.5857664233575px',
							'2186.4598540145985px 824.7901459854014px',
							'2179.7354014598536px 802.3996350364963px',
							'2170.5565693430653px 778.9142335766422px',
							'2167.4178832116786px 769.5346715328467px',
							'2166.1861313868612px 766.17700729927px',
							'2164.060218978102px 761.9251824817518px',
							'2161.934306569343px 758.5675182481751px',
							'2159.8083941605837px 755.2098540145985px',
							'2158.5766423357663px 752.7463503649634px',
							'2157.3448905109485px 747.8193430656934px',
							'2150.1824817518245px 733.5127737226277px',
							'2147.381386861314px 726.3594890510948px',
							'2144.9178832116786px 721.4324817518248px',
							'2143.6861313868612px 718.9689781021897px',
							'2141.560218978102px 714.7171532846714px',
							'2140.6660583941602px 712.9288321167883px',
							'2139.9361313868612px 712.198905109489px',
							'2139.0419708029194px 710.4105839416058px',
							'2139.0419708029194px 709.5164233576642px',
							'2137.2536496350363px 707.728102189781px',
							'2137.2536496350363px 706.8339416058394px',
							'2136.359489051095px 705.9397810218977px',
							'2136.359489051095px 705.9397810218977px',
							'2136.359489051095px 705.3102189781022px',
							'2135.465328467153px 704.4160583941605px',
							'2134.7262773722628px 703.67700729927px',
							'2134.7262773722628px 702.7828467153284px',
							'2133.832116788321px 700.9945255474452px',
							'2131.7062043795618px 697.6368613138685px',
							'2128.010948905109px 690.2463503649634px',
							'2126.222627737226px 688.4580291970802px',
							'2124.434306569343px 685.7755474452554px',
							'2124.434306569343px 684.8813868613138px',
							'2124.434306569343px 684.1423357664233px',
							'2123.540145985401px 683.2481751824816px',
							'2122.6459854014597px 681.4598540145985px',
							'2122.6459854014597px 680.7208029197079px',
							'2121.751824817518px 680.7208029197079px',
							'2121.751824817518px 680.0456204379561px',
							'2121.751824817518px 680.0456204379561px',
							'2121.751824817518px 679.3978102189781px',
							'2121.0127737226276px 677.7645985401459px',
							'2121.0127737226276px 676.8704379562043px',
							'2120.1186131386858px 676.1313868613138px',
							'2120.1186131386858px 675.2372262773722px',
							'2120.1186131386858px 674.507299270073px',
							'2119.443430656934px 673.8321167883211px',
							'2119.443430656934px 673.8321167883211px',
							'2119.881386861314px 674.8357664233577px',
							'2120.7664233576643px 675.2737226277371px',
							'2121.642335766423px 676.5967153284671px',
							'2123.5766423357663px 678.8686131386861px',
							'2124.744525547445px 680.8850364963503px',
							'2125.1824817518245px 681.7700729927006px',
							'2126.067518248175px 682.8193430656934px',
							'2127.7463503649633px 686.1861313868612px',
							'2130.88503649635px 691.1587591240875px',
							'2132.1441605839414px 693.6587591240875px',
							'2134.8448905109485px 699.8266423357663px',
							'2138.074817518248px 705.8667883211679px',
							'2141.131386861314px 710.7755474452554px',
							'2144.242700729927px 717.007299270073px',
							'2145.3284671532847px 718.8412408759124px',
							'2147.673357664233px 723.0474452554744px',
							'2149.7354014598536px 725.9945255474452px',
							'2152.536496350365px 728.9233576642335px',
							'2153.0656934306567px 729.8540145985401px',
							'2154.4251824817516px 731.6879562043795px',
							'2156.25px 733.5310218978102px',
							'2157.3448905109485px 736.1313868613138px',
							'2159.288321167883px 738.6861313868612px',
							'2161.405109489051px 742.0255474452554px',
							'2163.613138686131px 744.507299270073px',
							'2164.0510948905107px 745.3923357664233px',
							'2165.8211678832117px 747.3357664233577px',
							'2167.5912408759123px 749.1058394160583px',
							'2169.680656934306px 751.5967153284671px',
							'2171.0036496350363px 753.3759124087591px',
							'2171.9981751824816px 754.8448905109489px',
							'2172.4543795620434px 755.3193430656934px',
							'2172.8284671532847px 756.1313868613138px',
							'2173.193430656934px 756.8339416058393px',
							'2173.448905109489px 757.162408759124px',
							'2174.3430656934306px 758.1295620437955px',
							'2174.3430656934306px 758.1295620437955px',
							'2175.802919708029px 759.6076642335765px',
							'2176.742700729927px 761.3503649635036px',
							'2178.184306569343px 763.2664233576642px',
							'2179.9087591240873px 765.0912408759124px',
							'2180.392335766423px 766.4507299270073px',
							'2180.8302919708026px 766.8978102189781px',
							'2182.1441605839414px 768.6587591240875px',
							'2182.1441605839414px 768.6587591240875px',
							'2183.211678832117px 770.0456204379561px',
							'2183.613138686131px 770.7664233576642px',
							'2185.173357664233px 772.4178832116787px',
							'2186.0036496350363px 773.2481751824816px',
							'2186.450729927007px 774.0967153284671px',
							'2187.810218978102px 775.9306569343065px',
							'2187.810218978102px 775.9306569343065px',
							'2188.613138686131px 776.7518248175182px',
							'2188.613138686131px 776.7518248175182px',
							'2188.9781021897807px 776.8430656934306px',
							'2188.9781021897807px 776.1861313868612px',
							'2188.9781021897807px 776.1861313868612px',
							'2188.53102189781px 775.0729927007299px',
							'2187.6368613138684px 774.1788321167883px',
							'2187.1897810218975px 773.8777372262773px',
							'2186.5510948905107px 773.1295620437955px',
							'2186.149635036496px 772.7098540145985px',
							'2185.711678832117px 772.2536496350365px',
							'2184.507299270073px 770.9945255474452px',
							'2183.60401459854px 769.7262773722628px',
							'2183.60401459854px 769.7262773722628px',
							'2182.4543795620434px 768.1751824817518px',
							'2181.9890510948903px 767.7919708029196px',
							'2181.0857664233577px 766.8886861313867px',
							'2179.479927007299px 764.8357664233577px',
							'2178.7773722627735px 764.133211678832px',
							'2177.025547445255px 762.3813868613138px',
							'2175.282846715328px 760.6386861313867px',
							'2173.430656934306px 758.7864963503649px',
							'2169.507299270073px 756.4963503649634px',
							'2160.775547445255px 749.2883211678832px',
							'2153.5127737226276px 743.6405109489051px',
							'2148.7317518248174px 740.4379562043795px',
							'2137.9562043795618px 732.0255474452554px',
							'2135.492700729927px 729.5620437956204px',
							'2130.1003649635036px 726.3321167883211px',
							'2124.70802919708px 722.1897810218977px',
							'2118.038321167883px 715.8667883211679px',
							'2114.169708029197px 711.9708029197079px',
							'2111.03102189781px 708.2846715328467px',
							'2107.4543795620434px 704.0602189781022px',
							'2105.5474452554745px 702.1350364963503px',
							'2101.140510948905px 697.691605839416px',
							'2096.7335766423357px 692.6642335766422px',
							'2092.5912408759123px 688.5218978102189px',
							'2088.0656934306567px 683.9963503649634px',
							'2084.3156934306567px 680.2463503649634px',
							'2077.7463503649633px 674.9087591240875px',
							'2076.3412408759123px 673.5036496350365px',
							'2071.9069343065694px 670.2919708029196px',
							'2069.479927007299px 667.8649635036496px',
							'2065.109489051095px 663.4945255474452px',
							'2063.4032846715327px 661.7883211678832px',
							'2057.472627737226px 657.0894160583941px',
							'2054.1149635036495px 654.9543795620438px',
							'2052.4361313868612px 653.2755474452554px',
							'2048.120437956204px 649.9361313868612px',
							'2044.133211678832px 647.1806569343065px',
							'2041.715328467153px 645.4014598540145px',
							'2035.802919708029px 639.7171532846714px',
							'2033.8868613138684px 637.8193430656934px',
							'2030.0547445255472px 633.9872262773722px',
							'2027.28102189781px 631.7974452554744px',
							'2022.9105839416056px 627.4452554744526px',
							'2019.5437956204378px 624.0784671532846px',
							'2017.8649635036495px 623.0109489051094px',
							'2012.3266423357663px 616.8613138686131px',
							'2011.1405109489049px 615.2007299270073px',
							'2008.3667883211676px 612.2718978102189px',
							'2005.2007299270072px 608.4032846715328px',
							'2001.8795620437954px 605.4653284671532px',
							'2000.8485401459852px 604.4616788321167px',
							'1998.9324817518248px 602.5729927007299px',
							'1997.9379562043794px 600.7116788321167px',
							'1995.6751824817516px 598.8594890510949px',
							'1994.78102189781px 597.9653284671532px',
							'1994.516423357664px 597.2627737226277px',
							'1992.3905109489049px 595.6021897810218px',
							'1991.861313868613px 594.7445255474452px',
							'1990.5109489051092px 592.9105839416058px',
							'1988.266423357664px 590.9671532846714px',
							'1986.4142335766421px 589.1514598540145px',
							'1984.972627737226px 587.2901459854014px',
							'1983.5766423357663px 586.2956204379561px',
							'1982.6368613138684px 584.9178832116788px',
							'1981.7427007299268px 584.0237226277371px',
							'1980.1368613138684px 582.235401459854px',
							'1980.1368613138684px 582.235401459854px',
							'1979.3156934306567px 581.8613138686131px',
							'1978.1386861313867px 581.1131386861314px',
							'1978.1386861313867px 581.1131386861314px',
							'1977.7828467153283px 580.6751824817518px',
							'1977.4178832116786px 580.2463503649634px',
							'1977.4178832116786px 580.2463503649634px',
							'1977.0711678832115px 579.8631386861314px',
							'1977.0711678832115px 579.8631386861314px',
							'1976.7427007299268px 579.5529197080291px',
							'1976.7427007299268px 579.5529197080291px',
							'1976.7335766423357px 579.5255474452555px',
							'1976.706204379562px 580.8120437956204px',
							'1976.706204379562px 581.5602189781022px',
							'1976.706204379562px 583.3576642335765px',
							'1976.706204379562px 584.1605839416058px',
							'1976.706204379562px 586.9069343065693px',
							'1976.706204379562px 586.9069343065693px',
							'1976.706204379562px 588.3667883211679px',
							'1976.706204379562px 593.0474452554744px',
							'1976.706204379562px 593.9324817518248px',
							'1976.706204379562px 593.9324817518248px',
							'2013.302919708029px 629.9178832116788px',
							'2060.1824817518245px 680.4105839416058px',
							'2109.479927007299px 737.2718978102189px',
							'2168.759124087591px 796.5510948905109px',
							'2199.3430656934306px 830.7481751824816px',
							'2260.7481751824816px 892.1532846715328px',
							'2260.7481751824816px 892.1532846715328px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2258.6861313868612px 889.92700729927px',
							'2260.7481751824816px 891.5875912408759px',
							'2260.7481751824816px 882.2080291970802px',
							'2260.7481751824816px 859.8175182481751px',
							'2260.7481751824816px 837.42700729927px',
							'2258.5036496350363px 818.6313868613138px',
							'2253.795620437956px 804.5620437956204px',
							'2252.9014598540143px 801.2043795620438px',
							'2252.007299270073px 797.8467153284671px',
							'2249.881386861314px 794.4890510948904px',
							'2247.4178832116786px 789.5620437956204px',
							'2247.4178832116786px 787.0985401459853px',
							'2244.616788321168px 779.0510948905109px',
							'2243.38503649635px 776.5875912408759px',
							'2243.38503649635px 773.2299270072992px',
							'2242.4908759124087px 771.441605839416px',
							'2242.4908759124087px 769.6532846715328px',
							'2241.760948905109px 766.4598540145985px',
							'2241.760948905109px 764.6715328467153px',
							'2241.760948905109px 761.3138686131387px',
							'2241.760948905109px 757.956204379562px',
							'2241.760948905109px 757.0620437956204px',
							'2241.760948905109px 754.3795620437955px',
							'2241.760948905109px 752.5912408759124px',
							'2241.760948905109px 751.6970802919708px',
							'2241.760948905109px 751.0218978102189px',
							'2241.760948905109px 750.2828467153284px',
							'2241.760948905109px 747.6003649635036px',
							'2241.760948905109px 746.706204379562px',
							'2241.760948905109px 742.4543795620438px',
							'2241.760948905109px 739.9908759124087px',
							'2241.760948905109px 739.2518248175182px',
							'2241.760948905109px 738.3576642335765px',
							'2241.760948905109px 737.7098540145985px',
							'2241.760948905109px 737.7098540145985px',
							'2241.760948905109px 737.1076642335765px',
							'2241.760948905109px 737.1076642335765px',
							'2239.361313868613px 737.1076642335765px',
							'2235.21897810219px 737.1076642335765px',
							'2224.0054744525546px 737.1076642335765px',
							'2217.518248175182px 737.1076642335765px',
							'2213.941605839416px 737.1076642335765px',
							'2200.0638686131383px 737.1076642335765px',
							'2195.374087591241px 737.1076642335765px',
							'2188.8868613138684px 737.1076642335765px',
							'2182.0164233576643px 737.1076642335765px',
							'2173.147810218978px 737.1076642335765px',
							'2165.8302919708026px 737.1076642335765px',
							'2158.67700729927px 737.1076642335765px',
							'2149.2974452554745px 737.1076642335765px',
							'2143.45802919708px 737.1076642335765px',
							'2135.611313868613px 737.1076642335765px',
							'2128.120437956204px 737.1076642335765px',
							'2121.6879562043796px 738.1569343065693px',
							'2115.346715328467px 738.2937956204379px',
							'2110.866788321168px 738.3029197080291px',
							'2106.5693430656934px 739.4616788321167px',
							'2102.28102189781px 739.507299270073px',
							'2098.877737226277px 739.507299270073px',
							'2094.7354014598536px 739.507299270073px',
							'2088.3120437956204px 740.7299270072992px',
							'2086.9981751824816px 740.7299270072992px',
							'2079.479927007299px 740.7299270072992px',
							'2077.399635036496px 740.7299270072992px',
							'2071.0857664233577px 741.1952554744526px',
							'2069.552919708029px 741.7609489051094px',
							'2064.9635036496347px 741.934306569343px',
							'2063.102189781022px 741.934306569343px',
							'2061.2773722627735px 741.934306569343px',
							'2059.4890510948903px 741.934306569343px',
							'2058.7408759124087px 741.934306569343px',
							'2057.317518248175px 741.934306569343px',
							'2056.423357664233px 741.934306569343px',
							'2056.423357664233px 741.934306569343px',
							'2055.5656934306567px 741.934306569343px',
							'2055.5656934306567px 741.934306569343px',
							'2056.0127737226276px 741.934306569343px',
							'2057.691605839416px 741.934306569343px',
							'2059.5164233576643px 741.934306569343px',
							'2061.3503649635036px 741.934306569343px',
							'2063.96897810219px 741.934306569343px',
							'2066.4324817518245px 741.934306569343px',
							'2069.78102189781px 741.934306569343px',
							'2076.9160583941602px 741.934306569343px',
							'2083.1660583941602px 741.934306569343px',
							'2094.7992700729924px 741.934306569343px',
							'2113.412408759124px 741.934306569343px',
							'2128.859489051095px 741.934306569343px',
							'2141.979927007299px 741.0857664233577px',
							'2157.4361313868612px 740.0821167883211px',
							'2165.346715328467px 740.0273722627736px',
							'2179.63503649635px 740.0091240875912px',
							'2192.1259124087587px 739.9908759124087px',
							'2213.60401459854px 739.9908759124087px',
							'2218.430656934306px 739.9908759124087px',
							'2231.852189781022px 739.9908759124087px',
							'2251.1587591240873px 739.9908759124087px',
							'2265.155109489051px 739.9908759124087px',
							'2276.8795620437954px 739.9908759124087px',
							'2286.7335766423357px 739.9908759124087px',
							'2295.383211678832px 739.9908759124087px',
							'2302.7554744525546px 739.9908759124087px',
							'2308.8229927007296px 739.9908759124087px',
							'2315.95802919708px 739.9908759124087px',
							'2323.2846715328465px 739.9908759124087px',
							'2330.7208029197077px 739.9908759124087px',
							'2339.0875912408756px 739.9908759124087px',
							'2345.602189781022px 741.0310218978102px',
							'2351.943430656934px 741.17700729927px',
							'2355.7208029197077px 741.9981751824816px',
							'2359.9543795620434px 742.4817518248175px',
							'2363.448905109489px 742.9379562043795px',
							'2366.870437956204px 744.1697080291971px',
							'2368.640510948905px 744.1697080291971px',
							'2369.525547445255px 744.6076642335765px',
							'2369.525547445255px 744.6076642335765px',
							'2369.9635036496347px 745.3467153284671px',
							'2369.9635036496347px 745.3467153284671px',
							'2370.3375912408756px 746.6514598540145px',
							'2374.0510948905107px 747.9105839416058px',
							'2374.0510948905107px 747.9105839416058px',
							'2374.0510948905107px 749.7171532846714px',
							'2367.3357664233577px 761.1222627737226px',
							'2360.620437956204px 772.3083941605839px',
							'2305.88503649635px 824.4525547445255px',
							'2222.198905109489px 898.8321167883211px',
							'2083.832116788321px 987.2627737226277px',
							'1980.8211678832115px 1056.6240875912408px',
							'1861.6149635036495px 1139.4160583941605px',
							'1713.6313868613138px 1253.7864963503648px',
							'1640.1642335766421px 1318.640510948905px',
							'1605.948905109489px 1352.8375912408758px',
							'1566.7883211678832px 1391.9799270072992px',
							'1537.5912408759123px 1421.1587591240875px',
							'1515.7390510948903px 1440.419708029197px',
							'1493.8868613138684px 1457.4361313868612px',
							'1471.4963503649633px 1470.8485401459852px',
							'1453.5766423357663px 1484.2609489051094px',
							'1434.7810218978102px 1492.5273722627735px',
							'1422.4908759124087px 1499.4434306569342px',
							'1410.2007299270072px 1504.7992700729926px',
							'1400.8211678832115px 1509.4799270072992px',
							'1391.4416058394158px 1512.6003649635036px',
							'1386.514598540146px 1513.8229927007299px',
							'1377.1350364963503px 1515.383211678832px',
							'1369.9817518248174px 1515.383211678832px',
							'1360.6021897810217px 1516.9434306569342px',
							'1353.448905109489px 1518.1660583941605px',
							'1344.0693430656934px 1519.7262773722628px',
							'1336.9160583941605px 1520.948905109489px',
							'1327.2992700729926px 1522.1715328467153px',
							'1323.9416058394158px 1523.0565693430656px',
							'1319.014598540146px 1524.2791970802919px',
							'1314.0875912408758px 1525.5018248175181px',
							'1310.7299270072992px 1525.5018248175181px',
							'1307.3722627737225px 1526.7244525547444px',
							'1305.5839416058393px 1527.6094890510947px',
							'1303.7956204379561px 1527.6094890510947px',
							'1300.4379562043794px 1529.7171532846714px',
							'1297.0802919708028px 1530.9397810218977px',
							'1295.2919708029196px 1531.824817518248px',
							'1291.9343065693429px 1532.7098540145985px',
							'1290.1459854014597px 1532.7098540145985px',
							'1289.2518248175181px 1533.5948905109487px',
							'1288.3576642335765px 1533.5948905109487px',
							'1287.6824817518248px 1533.5948905109487px',
							'1287.6824817518248px 1533.5948905109487px',
							'1287.0346715328467px 1533.5948905109487px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
